/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypeModel } from "../../../Utils/Models";
import AddOrUpdateModel from "../../GenericComponents/AddOrUpdateModel";
import { useEffect, useRef, useState } from "react";
import { Vocabulary } from "../../../Utils/Vocabulary";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { onChangeTextField } from "../../../Utils/Utils";

type TypeProps = {
  editType: TypeModel | null;
  open: boolean;
  addOrUpdateType: (types: TypeModel | null) => void;
  onClose: () => void;
};

export default function Type(props: TypeProps) {
  const { editType, open, addOrUpdateType, onClose } = props;
  const ref: any = useRef();
  const [pressOnSubmit, setPressOnSubmit] = useState(false);
  const [types, setType] = useState<TypeModel>(new TypeModel());

  /**
   *
   */
  useEffect(() => {
    if (editType) {
      setType(editType);
    } else {
      setType(new TypeModel());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editType]);

  /**
   *
   */
  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  /**
   *
   */
  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }

  return (
    <ValidatorForm ref={ref} onSubmit={() => addOrUpdateType(types)}>
      <AddOrUpdateModel
        open={open}
        title={Vocabulary.type}
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
      >
        <TextValidator
          size="small"
          label={Vocabulary.name}
          name="name"
          value={types.name}
          onChange={(e: any) => setType(onChangeTextField(e, types))}
          validators={["required"]}
          errorMessages={[Vocabulary.requiredField]}
          fullWidth
          style={{ marginBottom: 20 }}
        />
        <TextValidator
          size="small"
          label={Vocabulary.description}
          name="description"
          value={types.description}
          onChange={(e: any) => setType(onChangeTextField(e, types))}
          fullWidth
        />
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
